import React from "react";
import { Box } from "@mui/material";
import { ShareActionProvider } from "../contexts/ShareActionContext";
import TaxCalculator from "../components/tools/TaxCalculator";

const SharedTaxCalculatorToolPage: React.FC = () => {
  return (
    <ShareActionProvider>
      <Box sx={{ maxWidth: 1100, mx: "auto", p: { xs: 2, sm: 3 } }}>
        <TaxCalculator />
      </Box>
    </ShareActionProvider>
  );
};

export default SharedTaxCalculatorToolPage;
